// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "../tables/LatestJobs.css";

// const AllAdmitCards = () => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((jobs) => {
//         const filtered = jobs.filter(
//           (job) => job.admitCard && job.admitCard.length > 0
//         );

//         const sorted = filtered.sort((a, b) => {
//           const aLatest = Math.max(
//             ...a.admitCard.map((card) => new Date(card.updatedAt).getTime() || 0)
//           );
//           const bLatest = Math.max(
//             ...b.admitCard.map((card) => new Date(card.updatedAt).getTime() || 0)
//           );
//           return bLatest - aLatest;
//         });

//         setData(sorted);
//       })
//       .catch((err) => console.error("Failed to fetch admit cards:", err));
//   }, []);

//   return (
//     <div className="table-card" style={{ maxWidth: "900px", margin: "2rem auto" }}>
//       <h3 className="table-title">All Admit Cards</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((job, idx) => (
//             <tr key={idx}>
//               <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span style={{ fontWeight: "bold", color: "#000", fontSize: "20px" }}>•</span>
//                 <a
//                   href={`/job/${job.slug}`}
//                   className="job-link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(`/job/${job.slug}`);
//                   }}
//                   style={{
//                     textDecoration: "none",
//                     color: "#007bff",
//                     fontWeight: "500"
//                   }}
//                 >
//                   {job.JobTitle}
//                 </a>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default AllAdmitCards;




import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../tables/LatestJobs.css";

const AllAdmitCards = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    fetch(`${API_URL}/jobs/admit-cards`)
      .then((res) => res.json())
      .then((jobs) => {
        console.log("Fetched All Admit Cards:", jobs);

        const sorted = jobs.sort((a, b) => {
          const aLatest = Math.max(
            ...a.admitCard.map((card) => new Date(card.updatedAt || 0).getTime())
          );
          const bLatest = Math.max(
            ...b.admitCard.map((card) => new Date(card.updatedAt || 0).getTime())
          );
          return bLatest - aLatest;
        });

        setData(sorted);
      })
      .catch((err) => console.error("Failed to fetch admit cards:", err));
  }, []);

  return (
    <div
      className="table-card"
      style={{ maxWidth: "900px", margin: "2rem auto" }}
    >
      <h3 className="table-title">All Admit Cards</h3>
      <table className="styled-table">
        <thead>
          <tr>
            <th>Exam</th>
          </tr>
        </thead>
        <tbody>
          {data.map((job, idx) => (
            <tr key={idx}>
              <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#000",
                    fontSize: "20px",
                  }}
                >
                  •
                </span>
                <a
                  href={`/job/${job.slug}`}
                  className="job-link"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/job/${job.slug}`);
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#007bff",
                    fontWeight: "500",
                  }}
                >
                  {job.JobTitle}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllAdmitCards;
